"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionBusRoleSchema = exports.ComponentFunctionBusRole = void 0;
const zod_1 = require("zod");
var ComponentFunctionBusRole;
(function (ComponentFunctionBusRole) {
    ComponentFunctionBusRole["Controller"] = "controller";
    ComponentFunctionBusRole["Peripheral"] = "peripheral";
})(ComponentFunctionBusRole || (exports.ComponentFunctionBusRole = ComponentFunctionBusRole = {}));
exports.ComponentFunctionBusRoleSchema = zod_1.z.nativeEnum(ComponentFunctionBusRole);
//# sourceMappingURL=ComponentFunctionBusRole.js.map